import { render, staticRenderFns } from "./DevelopmentHistory.vue?vue&type=template&id=09b5ea6d"
import script from "./DevelopmentHistory.vue?vue&type=script&lang=js"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentHistory.vue?vue&type=style&index=0&id=09b5ea6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports